/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { R as index$L } from '../../index-e5fa4dec.js';
import { extend } from '../extend/index.js';
import showActionSheet$1 from './dingTalk/index.js';
import '../../tslib.es6-e01eabb2.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';

/**
 * ActionSheet 选择框
 * API：https://yuque.antfin.com/cn-xt/htc47g/tzr9pt
 * @returns {Promise<unknown>} promise调用结果
 * @example 使用案例：
 * import { showActionSheet } from '@alife/cn-uni-api'; // h5、小程序通用包
 *
 * showActionSheet({ title: '标题', item: ['内容1', '内容2', '内容3'] })
 *   .then((res) => {
 *     console.log(res.index, '选中项');
 *   })
 *   .catch((error) => {
 *     console.log(error);
 *   });
 * @author 敬文
 */
var showActionSheet = extend({
    web: {
        dingTalk: showActionSheet$1,
    },
}, 
/** baseShowActionSheet 支持windvane容器、nebula容器、小程序容器 */
index$L);

export { showActionSheet };
